import React from "react";
import { Form, FormGroup, Label, Input, Button, Card, CardBody, Row, Col } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AreaSelect from "../trabajando_selectors/areas/Select";
import JobTypeSelect from "../trabajando_selectors/job_types/Select";
import CompanyActivitySelect from "../trabajando_selectors/company_activities/Select";
import WorkDaySelect from "../trabajando_selectors/work_days/Select";
import ApplicantProfileSelect from "../trabajando_selectors/applicant_profiles/Select";
import EducationLevelSelect from "../trabajando_selectors/education_levels/Select";
import EducationStateSelect from "../trabajando_selectors/education_states/Select";
import SoftwareLevelSelect from "../trabajando_selectors/software_levels/Select";
import StateSelect from "../trabajando_selectors/states/Select";
import CitySelect from "../trabajando_selectors/cities/Select";
import FieldWrapper from "../commons/FieldWrapper";
import DraftInput from "../commons/DraftInput";

const TrabajandoPublicationForm  = props => {
  const {
    trabajandoPublication,
    errors = {},
    handleChange,
    handleChangeTrabajandoPublication,
    handleChangeTrabajandoFields,
    handleChangeDescription,
    handleChangeRequirement,
    handleSelectorChange,
    handleDateChange,
    handleSubmit,
    submitting
  } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <Card className="mb-4 material-shadow">
        <h3 className="card-header h6 fw-bold">
          <i className="fas fa-briefcase me-2" aria-hidden="true"></i>
          Publicación de Oferta Laboral en Trabajando
        </h3>
        <CardBody>
          <Row>
            <Col lg="12" md="12">
              <FormGroup>
                <Label htmlFor="title" className="input_required">
                  Título de publicación
                </Label>
                <FieldWrapper errors={trabajandoPublication.title.errors}>
                  <Input
                    id="title"
                    name="title"
                    placeholder="Título de publicación"
                    type="text"
                    maxLength={60}
                    onChange={handleChangeTrabajandoPublication}
                    value={trabajandoPublication.title.value}
                  />
                </FieldWrapper>
              </FormGroup>
              
              <FormGroup>
                <Label for="requirements" className="input_required">
                  Requerimientos Mínimos
                </Label>
                <FieldWrapper errors={trabajandoPublication.requirements.errors}>
                  <DraftInput onChangeInput={handleChangeRequirement} value={trabajandoPublication.requirements.value} />
                </FieldWrapper>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label htmlFor="company_activity" className="input_required">Actividad de la empresa</Label>
                <FieldWrapper errors={trabajandoPublication.trabajandoField.company_activity.errors}>
                  <CompanyActivitySelect
                    value={trabajandoPublication.trabajandoField.company_activity}
                    handleChange={handleChangeTrabajandoFields}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label htmlFor="area" className="input_required">Área</Label>
                <FieldWrapper errors={trabajandoPublication.trabajandoField.area.errors}>
                  <AreaSelect
                    value={trabajandoPublication.trabajandoField.area}
                    handleChange={handleChangeTrabajandoFields}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label htmlFor="job_type" className="input_required">Cargo</Label>
                <FieldWrapper errors={trabajandoPublication.trabajandoField.job_type.errors}>
                  <JobTypeSelect
                    value={trabajandoPublication.trabajandoField.job_type}
                    handleChange={handleChangeTrabajandoFields}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label htmlFor="applicant_profile" className="input_required">Perfíl Académico</Label>
                <FieldWrapper errors={trabajandoPublication.trabajandoField.applicant_profile.errors}>
                  <ApplicantProfileSelect
                    value={trabajandoPublication.trabajandoField.applicant_profile}
                    handleChange={handleChangeTrabajandoFields}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label htmlFor="education_level" className="input_required">Nivel Académico</Label>
                <FieldWrapper errors={trabajandoPublication.trabajandoField.education_level.errors}>
                  <EducationLevelSelect
                    value={trabajandoPublication.trabajandoField.education_level}
                    handleChange={handleChangeTrabajandoFields}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label htmlFor="education_state" className="input_required">Estado Académico</Label>
                <FieldWrapper errors={trabajandoPublication.trabajandoField.education_state.errors}>
                  <EducationStateSelect
                    value={trabajandoPublication.trabajandoField.education_state}
                    handleChange={handleChangeTrabajandoFields}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label htmlFor="software_level" className="input_required">Manejo de software</Label>
                <FieldWrapper errors={trabajandoPublication.trabajandoField.software_level.errors}>
                  <SoftwareLevelSelect
                    value={trabajandoPublication.trabajandoField.software_level}
                    handleChange={handleChangeTrabajandoFields}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label htmlFor="work_day" className="input_required">Jornada Laboral</Label>
                <FieldWrapper errors={trabajandoPublication.trabajandoField.work_day.errors}>
                  <WorkDaySelect
                    value={trabajandoPublication.trabajandoField.work_day}
                    handleChange={handleChangeTrabajandoFields}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                  <Label htmlFor="desactivate_at" className="input_required">
                    Fecha Expiración (30 días máx.)
                  </Label>
                  <FieldWrapper errors={trabajandoPublication.desactivate_at.errors}>
                    <Input
                      id="desactivate_at"
                      name="desactivate_at"
                      placeholder="Fecha Expiración"
                      type="date"
                      onChange={handleChangeTrabajandoPublication}
                      value={trabajandoPublication.desactivate_at.value}
                    />
                  </FieldWrapper>
                </FormGroup>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md="12" className="text-end">
              <Button color="primary" type="submit" disabled={submitting}>
                {trabajandoPublication.id?.value ? "Actualizar publicación" : "Crear publicación"}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Form>
  );
};

export default TrabajandoPublicationForm;